<template>
  <div v-markdown="text" class="markdown__marked-text"></div>
</template>

<script>
export default {
  name: 'MarkdownText',

  props: {
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.markdown__marked-text {
  font-size: 14px;
  padding: 10px 20px;
  border-radius: 4px;
  max-width: 536px;
  background-color: var(--c-secondary-300);
}

.markdown__marked-text * {
  margin: 0;
  margin-top: 10px;
}

.markdown__marked-text.editor {
  cursor: pointer;
}
</style>
